var map = {
	"./bonk/preview.html": 9609,
	"./click/preview.html": 7960,
	"./fish-and-crips/preview.html": 5960,
	"./neom/preview.html": 4376,
	"./no-beaches/preview.html": 3920,
	"./stupi-square-and-sussy-circle/preview.html": 5811,
	"./the-boomer/preview.html": 4169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4862;